/**
 * Access token held in memory only (never in storage — XSS hardening).
 * The refresh token lives in the HttpOnly cookie `kfms_rt`.
 */
type Listener = (token: string | null) => void;

let accessToken: string | null = null;
let expiresAt = 0; // epoch ms
const listeners = new Set<Listener>();

export const tokenStore = {
  get(): string | null {
    return accessToken;
  },
  /** @param expiresInSec lifetime reported by the server (`expiresIn`) */
  set(token: string | null, expiresInSec?: number): void {
    accessToken = token;
    expiresAt = token && expiresInSec ? Date.now() + expiresInSec * 1000 : token ? Date.now() + 15 * 60_000 : 0;
    listeners.forEach((l) => l(token));
  },
  clear(): void {
    tokenStore.set(null);
  },
  /** true when the token expires within `marginMs` */
  isExpiring(marginMs = 15_000): boolean {
    return !!accessToken && Date.now() > expiresAt - marginMs;
  },
  expiresAt(): number {
    return expiresAt;
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
